(function(){
  const openPopUpLinks = document.querySelectorAll('.productCard__link--modal'),
        closeModalButtons = document.querySelectorAll('.comingSoon__close'),
        closeButtons = document.querySelectorAll('.comingSoon__closeButton');

  function openNotifyModal(event) {
    const overflowBlock = document.querySelector('.overflowBlock');

    event.preventDefault();

    if (event.currentTarget.hash) {
      const currentPopUp = document.querySelector(`[data-pop-up="${event.currentTarget.hash}"]`).closest('.comingSoon'),
            klaviyoButton = currentPopUp.querySelector('.comingSoon__content button');

      currentPopUp.classList.remove('comingSoon--hidden');
      overflowBlock.classList.remove('overflowBlock--hidden');

      klaviyoButton.addEventListener('click', e => {
        setInterval(function klaviyoFormInterval() {
          let klaviyoForm = currentPopUp.querySelector('.klaviyo-form');

          if(klaviyoForm.innerHTML == "") {
            changeSuccessMessage(currentPopUp);
            clearInterval(klaviyoFormInterval);
          }
        }, 100);
      });
    }
  }

  function closeNotifyModal() {
    const comingSoonPopUp = document.querySelector('.comingSoon:not(.comingSoon--hidden)'),
          overflowBlock = document.querySelector('.overflowBlock');

    comingSoonPopUp.classList.add('comingSoon--hidden');
    overflowBlock.classList.add('overflowBlock--hidden');
  }

  function changeSuccessMessage(currentPopUp) {
    let subtitle = currentPopUp.querySelector('.comingSoon__subtitle'),
        caption = currentPopUp.querySelector('.comingSoon__caption'),
        successMessage = currentPopUp.querySelector('.comingSoon__success'),
        closeButton = currentPopUp.querySelector('.comingSoon__closeButton');

    subtitle.classList.add('hidden');
    caption.classList.add('hidden');
    successMessage.classList.remove('hidden');
    closeButton.classList.remove('hidden');
  }

  openPopUpLinks.forEach(link => {
    link.addEventListener('click', (event) => {
      openNotifyModal(event);
    });
  });

  closeModalButtons.forEach(button => {
    button.addEventListener('click', closeNotifyModal);
  });

  closeButtons.forEach(button => {
    button.addEventListener('click', closeNotifyModal);
  });
})();
